<div [formGroup]="form" class="form-group">
        <mat-slide-toggle [formControlName]="config.id" [id]="config.id" (toggleChange)="valueToggleChange.emit($event)">{{config.attrs.label}}</mat-slide-toggle>
</div>
